import { ParametersMethods } from 'sigma-mappings';

export default {
  [ParametersMethods.GASES_RATIO_2007]: 'enums.engineering.chromatography.methods.iec-60599.gases-ratio-2007',
  [ParametersMethods.GASES_RATIO_2015]: 'enums.engineering.chromatography.methods.iec-60599.gases-ratio-2015',
  [ParametersMethods.DOERNENBURG]: 'enums.engineering.chromatography.methods.ieee-c57-104.doernenburg',
  [ParametersMethods.ROGERS]: 'enums.engineering.chromatography.methods.ieee-c57-104.rogers',
  [ParametersMethods.CONDITIONS_CLASSIFICATION]: 'enums.engineering.chromatography.methods.ieee-c57-104.classification-in-conditions',
  [ParametersMethods.KEY_GASES_1982]: 'enums.engineering.chromatography.methods.nbr-7274.key-gases-1982',
  [ParametersMethods.GASES_RATIO_2012]: 'enums.engineering.chromatography.methods.nbr-7274.gases-ratio-2012',
  [ParametersMethods.TRIANGLE_1]: 'enums.engineering.chromatography.methods.duval.triangle-1',
  [ParametersMethods.TRIANGLE_4]: 'enums.engineering.chromatography.methods.duval.triangle-4',
  [ParametersMethods.TRIANGLE_5]: 'enums.engineering.chromatography.methods.duval.triangle-5',
};

